import { requestAsync } from "lib/api";
import { getQuery } from "queries/schemas";

import { SCHEMA_REQUEST } from "constants/action-types";

export const fetchSchemas = (brandId: string) => {
    return (dispatch) => {
        return dispatch(requestAsync(getQuery(brandId))).then(({ status, translated, body }) => {
            if (status >= 200 && status < 300) {
                const ids = body.map((schema) => schema._id);
                return dispatch({
                    payload: ids,
                    type: SCHEMA_REQUEST,
                });
            }
        });
    };
};
